export default {"src":"/_next/static/media/education.4f781b78.svg","height":186,"width":215};